import format from "date-fns/format";
import * as math from "mathjs";

/**
 * 对日期按指定的格式进行格式化
 * @param date 日期
 * @param formatStr 格式
 * @param prefix 前缀
 * @returns {string|*}
 */
export function $dateFormat(date, formatStr = "yyyy-MM-dd HH:mm:ss", prefix) {
    if (date) {
        return (prefix ? prefix + " " : "") + format(typeof (date) == "string" ? new Date(date) : date, formatStr)
    } else {
        return "";
    }
}

/**
 * 将后面的参数依次填入到formatted预置的{}中
 * @param formatted 预处理的字符串, 包含{}
 * @param args 依次替换掉{}的对象
 * @returns {*}
 */
export function $format(formatted, ...args) {
    if (formatted.includes("{}") && args.length > 0 && args.length > 0) {
        formatted = formatted.replace("{}", args.shift());
        return $format(formatted, ...args);
    } else {
        return formatted;
    }
}

/**
 * 对提供的两个对象进行除法计算, 并保留指定的小数点返回结果
 * @param arg1 被除数
 * @param arg2 除数
 * @param digit 保留小数点位数, 默认2
 * @returns {string|number}
 */
export function $div(arg1, arg2, digit = 2) {
    if (arg1 === 0 || arg2 === 0) {
        return 0;
    }
    return math.divide(arg1, arg2).toFixed(digit).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
}

/**
 *
 * @param value
 * @returns {string|number}
 */
export function $numberSplit(value) {
    if (value) {
        return value.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
    return 0;
}

/**
 * 对对象进行深拷贝
 * @param data 对象
 * @returns {{}|*}
 */
export function $deepClone(data) {
    let obj;
    if (data instanceof Array) {
        obj = [];
    } else if (data instanceof Object) {
        obj = {};
    } else {
        //不再具有下一层次
        return data;
    }

    if (data instanceof Array) {
        for (let i = 0, len = data.length; i < len; i++) {
            obj.push($deepClone(data[i]));
        }
    } else if (data instanceof Object) {
        for (let key in data) {
            obj[key] = $deepClone(data[key]);
        }
    }
    return obj;
}